/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirmwareMasterApiServer {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getAllFirmwareList(
    currentPage,
    pageSize,
    search,
    firmwareType
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'firmwareMaster/getAllFirmwareList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&firmwareType=' +
        firmwareType
    );
  }

  getFirmwaresListNotAddedInState(
    currentPage,
    pageSize,
    search,
    firmwareType,
    stateServerId
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'firmwareMaster/getFirmwaresListNotAddedInState?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&firmwareType=' +
        firmwareType +
        '&stateServerId=' +
        stateServerId
    );
  }

  getStateFirmwares(
    currentPage,
    pageSize,
    search,
    firmwareType,
    userId,
    stateServerId
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'firmwareMaster/getStateFirmwares?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&firmwareType=' +
        firmwareType +
        '&userId=' +
        userId +
        '&stateServerId=' +
        stateServerId
    );
  }

  getFirmwareDetailsById(id): Observable<any> {
    return this.http.get(
      this.APIService + 'firmwareMaster/getFirmwareDetailsById?id=' + id
    );
  }

  addFirmware(formData: FormData): Observable<any> {
    return this.http.post(
      this.APIService + 'firmwareMaster/saveFirmware',
      formData
    );
  }

  deleteFirmware(firmwareId, userId): Observable<any> {
    return this.http.delete(
      this.APIService +
        'firmwareMaster/deleteFirmware?id=' +
        firmwareId +
        '&userId=' +
        userId
    );
  }
}
